export const hasDataflowEnhancements =
  import.meta.env.REACT_APP_ENABLE_DATAFLOW_ENHANCEMENTS === 'true'

export const hasForecastingReport =
  hasDataflowEnhancements &&
  import.meta.env.REACT_APP_ENABLE_FORECASTING_REPORT === 'true'

export const useSampleDataForExcel =
  hasForecastingReport && import.meta.env.REACT_APP_USE_SAMPLE_DATA === 'true'
